export default __webpack_public_path__ + "static/media/element_86.1e8ff738.jpg";